import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/auth/AuthProvider";

export interface UserSubscription {
  id: string;
  user_id: string;
  package_id: string;
  stripe_subscription_id: string;
  stripe_customer_id: string;
  status: string;
  trial_ends_at: string | null;
  current_period_end: string | null;
  canceled_at: string | null;
  paused_until: string | null;
  created_at: string;
}

export function useUserSubscription() {
  const { userId } = useAuth();

  return useQuery({
    queryKey: ["user-subscription", userId],
    queryFn: async () => {
      if (!userId) return null;

      const { data, error } = await supabase
        .from("user_subscriptions")
        .select("*")
        .eq("user_id", userId)
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) {
        console.error("Error fetching user subscription:", error);
        return null;
      }

      return data as UserSubscription | null;
    },
    enabled: !!userId,
  });
}
